import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from 'assets/locales/es.json';
import en from 'assets/locales/en.json';

export const DEFAULT_LANGUAGE = 'es';
export const SUPPORTED_LANGUAGES = ['es', 'en'];
export const LANGUAGE_STORAGE_KEY = 'language';

export const getStoredLanguage = (): string => {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
      return stored;
    }
  } catch {
    // ignore — fall through to the default
  }
  return DEFAULT_LANGUAGE;
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: getStoredLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,

  interpolation: { escapeValue: false },

  react: { useSuspense: false },
});

export default i18n;
